import { INBOUND, OUTBOUND } from 'constants/messageDirection';
import { extractSelectedTicketFromState, isSelectedTicketReviewTicket } from 'extractFromState';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMessagesInConversation } from 'util/messageUtil';

export const useTranscriptForML = () => {
  const conversation = useSelector((state) =>
    getMessagesInConversation(
      extractSelectedTicketFromState(state),
      state.conversation,
      state.user,
      isSelectedTicketReviewTicket(state)
    )
  );

  const transcript = useMemo(
    () =>
      conversation
        .filter(
          ({ direction, messageBody }) =>
            [OUTBOUND, INBOUND].includes(direction) &&
            messageBody !== 'User starting new ticket' &&
            messageBody !== 'escalating'
        )
        .map((message) => ({
          text: message.messageBody,
          sender: message.direction === INBOUND ? 'USER' : 'AGENT',
          id: message.messageId,
        })),
    [conversation]
  );

  return { transcript };
};
